// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"865":"8d02d1d4","971":"630cd211"}[chunkId] + ".css";
};